import React from "react";
import { Button, Col } from "react-bootstrap";
import ReactLoading from "react-loading";

import "./Buttons.css";

function MYTUpdateBtn({ size, onClick, isClicked }) {
  return (
    <Col className="mb-2">
      {isClicked ? (
        <Button className="action-btn update loader" size={size}>
          <ReactLoading type={"balls"} height={20} width={25} color="#fff" />
        </Button>
      ) : (
        <Button className="action-btn update" size={size} onClick={onClick}>
          Update
        </Button>
      )}
    </Col>
  );
}

export default MYTUpdateBtn;
